

































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Mutation, State } from 'vuex-class'
import Panel from './Panel/index.vue'
import PanelItem from './Panel/PanelItem.vue'
import * as api from '@/service/step-six'
import { getCountries, Country } from '@/components/CountrySelect.vue'
import { getCurrecyList, getOutsideBankList } from '@/service/common'
import {
  BusinessLicenseTextConfig,
  BusinessContactsTextConfig,
  StepsFourTextConfig,
} from '@/config'

const FileCard = {
  functional: true,
  render(h: any, context: any) {
    const { file } = context.props
    const $type = file.is_img
      ? 'image'
      : file.file_name.endsWith('pdf')
      ? 'pdf'
      : 'file'
    const attrs: any = { href: file.file_url }
    $type === 'file'
      ? (attrs.download = file.file_name)
      : (attrs.target = '_blank')
    return h(
      'a',
      { class: 'file-card', attrs },
      $type === 'image'
        ? [h('img', { class: 'file-card__img', attrs: { src: file.file_url } })]
        : [
            h('a-icon', {
              class: 'file-card__icon',
              props: { type: $type === 'pdf' ? 'file-pdf' : 'file' },
            }),
            h('span', { class: 'file-card__name' }, file.file_name),
          ]
    )
  },
}

@Component({
  components: { Panel, PanelItem, FileCard },
})
export default class DetailInfo extends Vue {
  @State bidType!: number
  @State coopChannel!: number
  @Mutation setApplyStatus!: Function
  @Mutation back!: Function
  @Mutation setStep!: Function

  data: any = null
  qualificationFiles: any = []
  contractFiles: any = []
  countries: Country[] = []
  currecyData: any = {}
  outsideBankList: any[] = []

  get bidTypeText() {
    return this.bidType === 8 ? '' : '公司'
  }

  get popContractInfo() {
    const file_url = this.data.bus_info.pop_contract_url
    return {
      is_img: /\.(jpe?g|png)$/i.test(file_url),
      file_url,
      file_name: file_url.split('/').pop(),
    }
  }

  get getTextConfig() {
    if (this.bidType === 7) {
      return {
        ...BusinessLicenseTextConfig.personal,
        ...BusinessContactsTextConfig.personal,
        ...StepsFourTextConfig.personal,
      }
    }
    if (this.bidType === 8) {
      return {
        ...BusinessContactsTextConfig.artist,
        ...StepsFourTextConfig.artist,
      }
    }
    return {
      ...BusinessLicenseTextConfig.normal,
      ...BusinessContactsTextConfig.normal,
      ...StepsFourTextConfig.normal,
    }
  }

  get fullBankCnaps() {
    if (!this.outsideBankList.length || !this.data.bus_info?.bank_cnaps)
      return '--'
    const bank = this.outsideBankList.find(
      (item) => item.bank_code.trim() === this.data.bus_info.bank_cnaps
    )
    return bank.bank_code + '-' + bank.bank_name
  }

  async created() {
    this.data = await api.queryDetailInfo()
    if (this.bidType === 6) {
      getCountries().then((data) => (this.countries = data))
      getCurrecyList().then((data) => (this.currecyData = data))
      getOutsideBankList().then((data) => (this.outsideBankList = data))
    }
  }

  @Watch('data.contract_list')
  setFiles(list: any[]) {
    list.forEach((file) => {
      file.contract_type
        ? this.contractFiles.push(file)
        : this.qualificationFiles.push(file)
    })
  }

  getCountryName(code: string) {
    return this.countries.find((country) => country.country_code === code)
      ?.country_name
  }

  transformCardType(value: any) {
    return (
      ({
        1: '中国居民身份证',
        2: '护照',
        3: '港澳居民来往内地通行证（回乡证）',
        4: '台湾居民来往大陆通行证（台胞证）',
        5: '外国人永久居留身份证',
        6: '中国港澳居民居住证',
        7: '中国台湾居民居住证',
      } as any)[value] || '--'
    )
  }

  transformCompanyType(value: string) {
    const map: any = {
      1: '品牌商',
      2: '经销商',
      3: '代理商',
    }
    return value.replace(/\d/g, ($0) => map[$0])
  }

  transformStoreType(value: any) {
    return ({
      1: '旗舰店',
      2: '品牌授权专卖店',
      3: '品类专营店',
      4: '卖场',
    } as any)[value]
  }

  submit() {
    this.$confirm({
      title: '温馨提示',
      content: '请务必确认所有信息正确无误，提交申请后将无法修改',
      okText: '确定提交',
      onOk: async () => {
        try {
          const data = await api.assureJoin()
          this.setApplyStatus(0)
          this.$emit('success', data)
        } catch (err) {
          if (this.bidType === 6) {
            this.$info({
              title: '资质信息有误',
              content: err.msg,
            })
          }
        }
      },
    })
  }
}
